import type { Layout } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR';
import {
    sections,
    singleRow,
    stack,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR/layoutTypings';
import { computedFn } from 'mobx-utils/lib/computedFn';
import type { ClientItemId } from 'owa-client-ids';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { getStringRibbonId, MailRibbonGroupId, MailRibbonControlId } from 'owa-ribbon-ids';
import { getReadRibbonId } from '../../../util/getReadRibbonId';
import { isFeatureEnabled } from 'owa-feature-flags';

export const getMLRHomeTabGroupLayouts = computedFn(
    (
        group: RibbonGroupId,
        popoutComposeViewState?: ComposeViewState,
        itemId?: ClientItemId
    ): Layout[] | undefined => {
        switch (group) {
            case MailRibbonGroupId.Group_Delete:
                return [
                    sections(
                        singleRow(
                            stack(
                                getStringRibbonId(MailRibbonControlId.IgnoreStopIgnore),
                                isFeatureEnabled('tri-breakoutPhishing-ribbonAndToolbar')
                                    ? getStringRibbonId(MailRibbonControlId.Phishing)
                                    : getReadRibbonId(MailRibbonControlId.JunkFlyout).toString(),
                                isFeatureEnabled('tri-breakoutPhishing-ribbonAndToolbar')
                                    ? getReadRibbonId(MailRibbonControlId.JunkFlyout).toString()
                                    : null
                            )
                        ),
                        singleRow(
                            getReadRibbonId(MailRibbonControlId.DeleteItem, itemId).toString()
                        ),
                        singleRow(getStringRibbonId(MailRibbonControlId.Archive))
                    ),
                ];

            case MailRibbonGroupId.Group_Move:
                return [
                    sections(
                        singleRow(getStringRibbonId(MailRibbonControlId.Sweep)),
                        singleRow(getStringRibbonId(MailRibbonControlId.Move)),
                        singleRow(getReadRibbonId(MailRibbonControlId.Rules, itemId).toString())
                    ),
                    sections(
                        singleRow(getStringRibbonId(MailRibbonControlId.Move)),
                        singleRow(
                            stack(
                                getStringRibbonId(MailRibbonControlId.Sweep),
                                getReadRibbonId(MailRibbonControlId.Rules).toString(),
                                null
                            )
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Respond:
                return [
                    sections(
                        singleRow(
                            getReadRibbonId(MailRibbonControlId.RespondReply, itemId).toString(),
                            getReadRibbonId(MailRibbonControlId.RespondReplyAll, itemId).toString(),
                            getReadRibbonId(MailRibbonControlId.RespondForward, itemId).toString(),
                            getStringRibbonId(MailRibbonControlId.ReplyWithMeeting)
                        )
                    ),
                    sections(
                        singleRow(
                            stack(
                                getReadRibbonId(
                                    MailRibbonControlId.RespondReply,
                                    itemId
                                ).toString(),
                                getReadRibbonId(
                                    MailRibbonControlId.RespondReplyAll,
                                    itemId
                                ).toString(),
                                getReadRibbonId(
                                    MailRibbonControlId.RespondForward,
                                    itemId
                                ).toString()
                            ),
                            getStringRibbonId(MailRibbonControlId.ReplyWithMeeting)
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Tags:
                return [
                    sections(
                        singleRow(
                            getReadRibbonId(MailRibbonControlId.ReadUnread, itemId).toString(),
                            getStringRibbonId(MailRibbonControlId.Categorize),
                            getReadRibbonId(MailRibbonControlId.FlagUnflag, itemId).toString(),
                            getStringRibbonId(MailRibbonControlId.PinUnpin),
                            getStringRibbonId(MailRibbonControlId.Snooze),
                            getReadRibbonId(MailRibbonControlId.AssignPolicy, itemId).toString()
                        )
                    ),
                    sections(
                        singleRow(
                            getReadRibbonId(MailRibbonControlId.ReadUnread, itemId).toString(),
                            stack(
                                getStringRibbonId(MailRibbonControlId.Categorize),
                                getReadRibbonId(MailRibbonControlId.FlagUnflag, itemId).toString(),
                                getStringRibbonId(MailRibbonControlId.PinUnpin)
                            ),
                            getStringRibbonId(MailRibbonControlId.Snooze),
                            getReadRibbonId(MailRibbonControlId.AssignPolicy, itemId).toString()
                        )
                    ),
                ];

            default:
                return undefined;
        }
    }
);
